import { RoutesWrapper } from "routes/Wrapper";

function App() {
  return <RoutesWrapper />;
}

export default App;
